<div class="page-container">
    <div class="row center-xs">
        <div class="col-xs-12 col-sm-11 col-md-9">
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h1>BOTON FLUTTER</h1>
                            <div class="text-content-bigger">El comercio puede conectarse con nuestra librería flutter
                                en menos de 2 horas.
                                La librería flutter es full dart, permitiendo la integración de cualquier tienda móvil
                                desarrollada en lenguaje de programación dart.
                            </div>
                            <div class="text-content-bigger">El formulario de pago se crea dinámicamente, haciendo
                                segura la captura y el envío de los datos de tarjeta.
                            </div>
                            <!-- <div class="text-content-bigger">El pago es solicitado al procesador de pagos y la respuesta
                                es mostrada al cliente sin errores y sin demoras.
                                El comercio recibe la notificación de autorización de los servidores de epago.
                            </div> -->
                            <!-- <div class="text-content-bigger">Descarga un ejemplo de integración completo al botón de
                                pago web, <a href="https://github.com/synapsolutions/shop-web">visita nuestro link en
                                    git.</a>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-xs-12">
                    <div class="img-container">
                        <img class="img" src="assets/img/flutter-agoraweb-button.png">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="text-container">
                        <div class="paragraph">
                            <h2>Instalación</h2>
                            <div class="text-content">La librería flutter es full dart, permitiendo la integración de
                                cualquier tienda móvil desarrollada en lenguaje de dart.
                            </div>
                            
                            <div class="text-content">1. Descargue y descomprima el archivo epago.zip. <br>
                                <a href="https://pay.button.epago.pe/flutter/latest/epago.zip">descárguelo
                                    aquí</a><br>
                            </div>
                            <div class="text-content">2. Cree el directorio "packages" en el
                                proyecto Flutter y copie el directorio "epago" completo del paso anterior.
                            </div>

                            <div class="text-content">3. Incluir la libreria en el pubspec del proyecto Flutter
                            </div>
                            <div class="code-content-sm">
                                <!--<iframe src="https://pastebin.com/embed_iframe/g4XHivPe"
                                    style="border:none;width:100%;height:75px;padding-bottom:10px;"></iframe>-->
                                <ng-gist userName="synapdevelopment" gistId="b70911494481b6d01cc57d41d8cf450d"
                                    fileName="epago-flutter-pubspec.yaml"></ng-gist>
                            </div>
                        </div>
                        <div class="paragraph">
                            <h2>Configuración</h2>

                            <div class="tab-wrap">
                                <input type="radio" name="tabs" id="tab1" checked>
                                <div class="tab-label-content" id="tab1-content">
                                    <label for="tab1">Pago con Formulario</label>
                                    <div class="tab-content"><app-flutter-agoraweb-form-button></app-flutter-agoraweb-form-button></div>
                                </div>
                                <input type="radio" name="tabs" id="tab2">
                                <div class="tab-label-content" id="tab2-content">
                                    <label for="tab2">Pago sin Formulario</label>
                                    <div class="tab-content"><app-flutter-agoraweb-noform-button></app-flutter-agoraweb-noform-button></div>
                                </div>
                                <div class="slide"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>